// src/App.tsx
import React, { JSX, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFoundPage from './pages/errors/NotFoundPage';
import routes from './routes';
import Loader from './pages/auth/components/Loader';
import { SidebarProvider } from './context/SidebarContext';
import { ToastContainer } from 'react-toastify';
// import AppToastContainer from "./components/AppToastContainer";
function App(): JSX.Element {
  const generateRoutes = (
    prefix: string,
    routeGroup: Record<string, React.ComponentType>,
  ) =>
    Object.entries(routeGroup).map(([path, Component]) => (
      <Route key={prefix + path} path={prefix + path} element={<Component />} />
    ));

  return (
    <Router>
      <SidebarProvider>
        <Suspense fallback={<Loader />}>
          <Routes>
            {routes.map(({ prefix, routes }) => generateRoutes(prefix, routes))}
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </SidebarProvider>
      {/* Toast Container for notifications */}
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </Router>
  );
}

export default App;
